import React from "react";
import {NavLink} from "react-router-dom";

const NavBarContainer = () => {
    return (
        <>
            <ul className="nav navbar-nav mr-auto">
                <NavLink to='/' className="nav-item nav-link">Home</NavLink>
                <NavLink to='/team' className="nav-item nav-link">Team</NavLink>
                <NavLink to='/about' className="nav-item nav-link">About</NavLink>
                <NavLink to='/news' className="nav-item nav-link">News</NavLink>
                <NavLink to='/contacts' className="nav-item nav-link">Contacts</NavLink>
            </ul>
        </>
    )
};
export default NavBarContainer;